import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { SkeletonAnimation } from '../../skeleton-loader.types';

@Component({
  selector: 'cm-skeleton-form-field',
  standalone: true,
  imports: [],
  templateUrl: './skeleton-form-field.component.html',
  styleUrl: './skeleton-form-field.component.less',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SkeletonFormFieldComponent {
  public readonly animation = input<SkeletonAnimation>('shimmer');
}
